import I18n from 'I18n';
import { getProductNameText, getProductNameTextFromApiName } from 'ui-addon-upgrades/_core/common/adapters/getProductNameText';
const _getButtonText = (i18nKey, productTitle) => {
  return I18n.text(`upgrades.upgradeButton.${i18nKey}`, {
    productTitle
  });
};
export const getUpgradeButtonText = (upgradeType, upgradeProduct) => {
  const productTitle = getProductNameText(upgradeProduct);
  return _getButtonText(upgradeType, productTitle);
};
export const getUpgradeButtonTextFromApiName = (upgradeType, apiName) => {
  const productTitle = getProductNameTextFromApiName(apiName);
  return _getButtonText(upgradeType, productTitle);
};